import styled from "styled-components";

export const AboutUsComp = styled.div`
    display: flex;
    margin: 2% 20% 5% 20%;
    @media (max-width: 1000px) {
        margin: 2% 10% 5% 10%;
    }
`;

export const AboutUsContent = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
`;

export const TextContent = styled.div`
    color: var(--purple-bhbusmidia);
    text-align: center;
    margin: 0% 5%;
`;

export const TextTitle = styled.div`
    h2 {
        font-family: "Montserrat";
        font-weight: normal;
        font-size: 25px;
        color:  var(--purple-bhbusmidia);
    }
`;

export const TextBody = styled.div`
    font-size: 24px;
    color: var(--purple-bhbusmidia);
    p {
        color: var(--purple-bhbusmidia);
        margin-top: 3%;
    }
`;

export const VideoContent = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 5%;
`;

export const NavMenu = styled.div`
    display: flex;
    text-align: center;
    align-items: center;
    font-size: 16px;
    margin: 0% 2%;
    color: var(--purple);
    font-weight: bold;
`;

export const NavUl = styled.ul``;

export const NavList = styled.p`
    padding: 5px;
`;


export const SearchDiv = styled.div``;

